<template>
  <div v-if="shouldDisplay" class="all-listing-filters">
    <transition name="collapse-fade">
      <div v-if="!collapsed" :class="['all-listing-filters-slot', { 'collapsed': collapsed, 'expanded': expanded }]" :style="filterStyle">
        <tag-listing-filters></tag-listing-filters>
        <variation-listing-filters></variation-listing-filters>
        <attribute-listing-filters></attribute-listing-filters>
      </div>
    </transition>
    <div v-if="!collapsed" @click="toggleExpand" class="show-more-btn">
      {{ expanded ? 'Δείτε Λιγότερα' : 'Δείτε Περισσότερα' }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TagListingFilters from './tag/filters/Components/TagListingFilters.vue'
import VariationListingFilters from './variations/filters/Components/VariationListingFilters.vue'
import AttributeListingFilters from './attributes/filters/Components/AttributeListingFilters.vue'

export default {
  name: 'AllListingFilters',
  components: {
    TagListingFilters,
    VariationListingFilters,
    AttributeListingFilters
  },
  data() {
    return {
      collapsed: false,
      expanded: false,
      maxHeight: 1000
    }
  },
  computed: {
    ...mapGetters([
      'getVariationsActive',
      'getListingVariationGroupCombos',
      'getAttributesActive',
      'getListingAttributeGroupCombos',
      'getListingTagGroupCombos'
    ]),
    shouldDisplay() {
      return this.shouldDisplayTags || this.shouldDisplayAttributes || this.shouldDisplayVariations
    },
    shouldDisplayTags() {
      return this.getListingTagGroupCombos.length > 0
    },
    shouldDisplayAttributes() {
      return this.getAttributesActive && this.getListingAttributeGroupCombos.length > 0
    },
    shouldDisplayVariations() {
      return this.getVariationsActive && this.getListingVariationGroupCombos.length > 0
    },
    filterStyle() {
      return this.expanded ? {} : { maxHeight: this.maxHeight + 'px', overflow: 'hidden' }
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    toggleExpand () {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style lang="scss" scoped>
.all-listing-filters {
  position: relative;
  width: 100%;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 30px;
  padding-bottom: 10px;

  &-slot {
    position: relative;
    display: grid;
    transition: max-height 0.5s ease;
  }

  &-title {
    cursor: pointer;
    font-size: 24px;
    font-weight: 900;
    margin: 0 0 15px 0;
    display: block;
    width: 100%;
    padding: 15px 0;
    border-bottom: 2px solid black;
    position: relative;

    &-text {

    }

    &-btn {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      text-align: center;
      background: unset;
      border: unset;
    }
  }
}

.ti-close {
  font-size: 14px;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
}

.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.5s;
}

.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
}

.show-more-btn {
  display: block;
  margin: 10px auto;
  padding: 10px 20px;
  cursor: pointer;
  background-color: #00b1db;
  color: white;
  border: none;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

section {
  background: unset;
}
</style>
